'use strict';
'use client';
import { j as p } from "../../../external/react/jsx-runtime.js";
import { useState as l } from "react";
import C from "../Input.js";
import r from "../../../external/card-validator/dist/index.js";
const h = ({ onChange: s, cardNumber: c }) => {
  const [u, d] = l(""), [v, o] = l(""), n = r.number(c), V = (a) => {
    var i;
    const e = a.target.value, t = r.cvv(
      e,
      (i = n.card) == null ? void 0 : i.code.size
    );
    d(e), s({
      value: e,
      isValid: t.isValid
    }), o(t.isPotentiallyValid ? "" : "Invalid CVV");
  }, m = (a) => {
    var t;
    if (a.target.value === "") return;
    r.cvv(
      a.target.value,
      (t = n.card) == null ? void 0 : t.code.size
    ).isValid || o("Invalid CVV");
  };
  return /* @__PURE__ */ p.jsx(
    C,
    {
      name: "cvv",
      label: "CVV",
      placeholder: "CVV",
      autoComplete: "cc-csc",
      inputMode: "numeric",
      value: u,
      onChange: V,
      onBlur: m,
      error: v,
      maxLength: 4,
      size: 4
    }
  );
};
export {
  h as default
};
